document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#shopify-section-template--21471739248866__featured_collection_UjQXqF');
  if (!section) return;

  section.querySelectorAll('h4.card__heading a').forEach(function (title) {
    title.style.display = '-webkit-box';
    title.style.webkitLineClamp = '1';
    title.style.webkitBoxOrient = 'vertical';
    title.style.overflow = 'hidden';

    const btn = document.createElement('span');
    btn.textContent = '+';
    btn.style.cssText = 'cursor:pointer;font-size:12px;margin-left:4px;';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const expanded = title.style.webkitLineClamp === 'unset';
      title.style.webkitLineClamp = expanded ? '1' : 'unset';
      title.style.overflow = expanded ? 'hidden' : 'visible';
      btn.textContent = expanded ? '+' : '-';
    });

    title.parentElement.appendChild(btn);
  });
});

function removeGBPText() {
  if (window.location.pathname.includes('/cart') || 
      window.location.pathname.includes('/checkout')) return;

  document.querySelectorAll('.price-item, .price-item bdi, bdi').forEach(function(el) {
    el.childNodes.forEach(function(node) {
      if (node.nodeType === 3) {
        node.textContent = node.textContent.replace(/\s*GBP/gi, '');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', removeGBPText);
if (document.readyState !== 'loading') removeGBPText();

document.addEventListener('mouseover', function(e) {
  const trigger = e.target.closest('.quick-buy-trigger');
  if (trigger) {
    trigger.style.opacity = '';
    trigger.style.visibility = '';
  }
});

document.addEventListener('mouseout', function(e) {
  const trigger = e.target.closest('.quick-buy-trigger');
  if (trigger && !trigger.closest('.card-wrapper').querySelector('.quick-buy-overlay.is-open')) {
    trigger.style.opacity = '';
    trigger.style.visibility = '';
  }
});

document.addEventListener('click', function(e) {

  // --- OPEN/CLOSE OVERLAY ---
  if (e.target.classList.contains('quick-buy-trigger')) {
    e.preventDefault();
    const card = e.target.closest('.card-wrapper');
    const overlay = card.querySelector('.quick-buy-overlay');
    const isOpen = overlay.classList.contains('is-open');
    document.querySelectorAll('.quick-buy-overlay.is-open').forEach(el => el.classList.remove('is-open'));
    if (!isOpen) {
      const trigger = e.target;
      const triggerRect = trigger.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      overlay.style.top = (triggerRect.bottom - cardRect.top) + 'px';
      overlay.style.bottom = 'auto';
      overlay.classList.add('is-open');
    }

  // --- SELECT A SIZE/OPTION BUTTON ---
  } else if (e.target.closest('.quick-buy-overlay__size')) {
    e.stopImmediatePropagation();
    const sizeBtn = e.target.closest('.quick-buy-overlay__size');
    const optionIndex = sizeBtn.dataset.optionIndex;
    const overlay = sizeBtn.closest('.quick-buy-overlay');

    // Deselect only buttons in the SAME option group
    overlay.querySelectorAll(`.quick-buy-overlay__size[data-option-index="${optionIndex}"]`).forEach(s => {
      s.classList.remove('selected');
      s.style.removeProperty('background-color');
      s.style.removeProperty('color');
      s.style.removeProperty('border-color');
    });

    // Select clicked button
    sizeBtn.classList.add('selected');
    sizeBtn.style.setProperty('background-color', '#000', 'important');
    sizeBtn.style.setProperty('color', '#fff', 'important');
    sizeBtn.style.setProperty('border-color', '#000', 'important');

    // Update button label
    const addBtn = overlay.querySelector('.quick-buy-overlay__btn');
    if (addBtn) addBtn.textContent = 'ADD TO BAG ▶';

    // --- UPDATE AVAILABILITY OF OTHER OPTION GROUPS ---
    const productHandle = overlay.querySelector('.quick-buy-overlay__btn').dataset.productHandle;
    fetch(`/products/${productHandle}.js`)
      .then(r => r.json())
      .then(product => {
        const allGroups = overlay.querySelectorAll('.quick-buy-overlay__sizes');

        // Build map of currently selected values per group index
        const selectedPerGroup = {};
        allGroups.forEach(g => {
          const idx = g.dataset.optionIndex;
          const sel = g.querySelector('.quick-buy-overlay__size.selected');
          if (sel) selectedPerGroup[idx] = sel.dataset.optionValue;
        });

        // For each OTHER group, update sold-out state based on current selections
        allGroups.forEach(g => {
          const groupIdx = g.dataset.optionIndex;
          if (groupIdx === optionIndex) return; // skip the group just clicked

          g.querySelectorAll('.quick-buy-overlay__size').forEach(optBtn => {
            const testValues = Object.assign({}, selectedPerGroup);
            testValues[groupIdx] = optBtn.dataset.optionValue;

            const available = product.variants.some(v => {
              return Object.entries(testValues).every(([idx, val]) => {
                return v[`option${parseInt(idx) + 1}`] === val;
              }) && v.available;
            });

            if (available) {
              optBtn.classList.remove('sold-out');
            } else {
              optBtn.classList.add('sold-out');
            }
          });
        });
      });

  // --- QUICK BUY SUBMIT ---
  } else if (e.target.closest('.quick-buy-overlay__btn')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const btn = e.target.closest('.quick-buy-overlay__btn');
    const overlay = btn.closest('.quick-buy-overlay');
    const productHandle = btn.dataset.productHandle;

    // Collect all selected option values
    const optionGroups = overlay.querySelectorAll('.quick-buy-overlay__sizes');
    const selectedValues = [];
    let allSelected = true;

    optionGroups.forEach(group => {
      const selected = group.querySelector('.quick-buy-overlay__size.selected');
      if (selected) {
        selectedValues.push(selected.dataset.optionValue);
      } else {
        allSelected = false;
      }
    });

    if (!allSelected) {
      const totalOptions = optionGroups.length;
      alert(totalOptions > 1 ? 'Please select a size and leg length' : 'Please select a size');
      return;
    }

    btn.textContent = 'ADDING...';
    btn.disabled = true;

    fetch(`/products/${productHandle}.js`)
      .then(res => res.json())
      .then(product => {
        const variant = product.variants.find(v => {
          return selectedValues.every((val, i) => v[`option${i + 1}`] === val);
        });

        if (!variant || !variant.available) {
          alert('Sorry, this combination is unavailable.');
          btn.textContent = 'Quick Buy ▶';
          btn.disabled = false;
          return;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variant.id,
            quantity: 1,
            sections: cartDrawer ? cartDrawer.getSectionsToRender().map(s => s.id) : [],
            sections_url: window.location.pathname
          })
        })
        .then(res => res.json())
        .then(response => {
          btn.textContent = 'ADDED ✓';
          btn.disabled = false;
          overlay.classList.remove('is-open');

          // Reset all option buttons
          overlay.querySelectorAll('.quick-buy-overlay__size').forEach(s => {
            s.classList.remove('selected');
            s.style.removeProperty('background-color');
            s.style.removeProperty('color');
            s.style.removeProperty('border-color');
          });

          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(response);
          }
        });
      })
      .catch(() => {
        btn.textContent = 'ERROR - TRY AGAIN';
        btn.disabled = false;
      });

  // --- CLOSE OVERLAY ON OUTSIDE CLICK ---
      } else if (e.target.closest('.wbs-card-heart')) {
    e.preventDefault();
    var heart = e.target.closest('.wbs-card-heart');
    var card = heart.closest('.card-wrapper');
    if (card) {
      var appBtn = card.querySelector('.Vtl-WishlistButton__WishlistIconButton');
      if (appBtn) {
        appBtn.click();
        var isWishlisted = heart.classList.toggle('wishlisted');
        var tooltip = heart.closest('.wbs-card-wishlist').querySelector('tooltip');
        if (tooltip) tooltip.textContent = isWishlisted ? 'Added To Wishlist' : 'Add To Wishlist';
      }
    }

  } else if (!e.target.closest('.quick-buy-overlay')) {
    document.querySelectorAll('.quick-buy-overlay.is-open').forEach(el => el.classList.remove('is-open'));
  }

});

// Fix: reveal images after filter AJAX reloads and Ajaxinate loads
function revealImages() {
  jQuery('.loading-image').removeClass('loading-image').addClass('loaded-image');
}

// Hook into Shopify's native filter render event
document.addEventListener('facets:updated', function() {
  setTimeout(revealImages, 500);
});

// Hook into filter form submits
document.querySelectorAll('form.facets').forEach(function(form) {
  form.addEventListener('submit', function() {
    setTimeout(revealImages, 1000);
  });
});

// Also observe DOM changes to the product grid
var grid = document.querySelector('#ProductGridContainer');
if (grid) {
  new MutationObserver(function() {
    if (jQuery('.loading-image').length > 0) {
      setTimeout(revealImages, 300);
    }
  }).observe(grid, { childList: true, subtree: true });
}

function updatePageUrl() {
  var nextLink = document.querySelector('#AjaxinatePagination a[href]');
  if (nextLink) {
    var nextUrl = new URL(nextLink.href);
    var currentPage = parseInt(nextUrl.searchParams.get('page') || '2') - 1;
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', currentPage);
    history.replaceState(null, '', currentUrl.toString());
  }
}

function reinitAjaxinate() {
  if (window.endlessScroll && typeof window.endlessScroll.destroy === 'function') {
    window.endlessScroll.destroy();
  }
  window.endlessScroll = new Ajaxinate({
    container: '#AjaxinateContainer',   // ← use ID not class
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    offset: 200,
    callback: updatePageUrl,
  });
}

// Reinit Ajaxinate when facet filters replace the product grid
var gridObserver = new MutationObserver(function(mutations) {
  var gridReplaced = mutations.some(function(m) {
    return m.removedNodes.length > 0;
  });
  if (gridReplaced) {
    // Destroy existing instance first
    if (window.endlessScroll && typeof window.endlessScroll.destroy === 'function') {
      window.endlessScroll.destroy();
      window.endlessScroll = null;
    }
    setTimeout(function() {
      if (document.querySelector('#AjaxinatePagination a[href]')) {
        reinitAjaxinate();
      }
    }, 150);
  }
});

var gridContainer = document.querySelector('#ProductGridContainer');
if (gridContainer) {
  gridObserver.observe(gridContainer, { childList: true, subtree: false });
}

console.log('custom.js loaded', new Date().getTime());

// Size selection warning on main product page
(function() {
  function initSizeWarning() {
    var addBtn = document.getElementById('product-form__submit');
    if (!addBtn) return;

    var existing = document.getElementById('size-warning-msg');
    if (existing) existing.remove();

    var warning = document.createElement('p');
    warning.id = 'size-warning-msg';
    warning.textContent = 'To continue, please complete your selection.';
    warning.style.cssText = 'color:red;font-size:13px;font-weight:500;max-height:0;overflow:hidden;transition:max-height 0.2s ease;margin:0;padding:0;display:block;';

    var buttonsContainer = addBtn.closest('.product-form__buttons');
    if (buttonsContainer) {
      buttonsContainer.insertAdjacentElement('beforebegin', warning);
    } else {
      addBtn.insertAdjacentElement('beforebegin', warning);
    }

    // Click handler
    addBtn.addEventListener('click', function(e) {
      var optionGroups = {};
      document.querySelectorAll('input[type="radio"][name^="globo-option"]').forEach(function(r) {
        if (!optionGroups[r.name]) optionGroups[r.name] = false;
        if (r.checked) optionGroups[r.name] = true;
      });

      var allSelected = Object.values(optionGroups).every(function(v) { return v; });

      if (!allSelected) {
        e.preventDefault();
        e.stopImmediatePropagation();
        warning.style.maxHeight = '40px';
        warning.style.padding = '0 0 8px 0';
      } else {
        warning.style.maxHeight = '0';
        warning.style.padding = '0';
      }
    }, true);

    // Hide warning when size clicked
    document.addEventListener('click', function(e) {
      var target = e.target.closest('label[for], input[type="radio"]');
      if (!target) return;
      var radio = target.tagName === 'LABEL'
        ? document.getElementById(target.htmlFor)
        : target;
      if (radio && radio.name && radio.name.indexOf('globo-option') === 0) {
        warning.style.maxHeight = '0';
        warning.style.padding = '0';
      }
    });
  }
    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeWarning);
  } else {
    initSizeWarning();
  }

})();

// Wishlist by Square — icon only styling
function styleWishlistBtn() {
  var btn = document.querySelector('div.Vtl-WishlistButton__AddToWishlist');
  if (btn) {
    btn.style.background = 'none';
    btn.style.border = 'none';
    btn.style.width = 'auto';
    btn.style.minWidth = 'unset';
    btn.style.boxShadow = 'none';
    var text = btn.querySelector('span.Vtl-WishlistButton__AddToWishlistText');
    if (text) text.style.display = 'none';
    var svg = btn.querySelector('span.Vtl-WishlistButton__HeartIconWrapper svg');
    if (svg) svg.style.fill = '#222222';
  }
}
document.addEventListener('DOMContentLoaded', styleWishlistBtn);
new MutationObserver(styleWishlistBtn).observe(document.body, { childList: true, subtree: true });

// Wishlist by Square — move collection card icons into product-icons row
function repositionWishlistIcons() {
  document.querySelectorAll('.Vtl-WishlistIcon__Wrapper.Vtl-CollectionCardWidget').forEach(function(icon) {
    // Fix inline positioning
    icon.style.position = 'static';
    icon.style.top = 'auto';
    icon.style.left = 'auto';
    icon.style.display = 'inline-flex';
    icon.style.alignItems = 'center';

    // Fix button styles
    var btn = icon.querySelector('.Vtl-WishlistButton__IconButton');
    if (btn) {
      btn.style.background = 'none';
      btn.style.border = 'none';
      btn.style.padding = '0';
      btn.style.boxShadow = 'none';
      btn.style.width = 'auto';
    }

    // Fix SVG fill
    var svg = icon.querySelector('svg');
    if (svg) svg.style.fill = '#222222';

    // Move into product-icons list if not already there
    var card = icon.closest('.card-wrapper');
    if (card) {
      var iconsList = card.querySelector('ul.product-icons');
      if (iconsList && !iconsList.contains(icon)) {
        var li = document.createElement('li');
        li.className = 'mobile-hide';
        li.appendChild(icon);
        iconsList.insertAdjacentElement('afterbegin', li);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', repositionWishlistIcons);
new MutationObserver(repositionWishlistIcons).observe(document.body, { childList: true, subtree: true });

// Sync wbs-card-heart fill with app wishlist state
function syncWishlistHearts() {
  document.querySelectorAll('.wbs-card-wishlist').forEach(function(li) {
    var card = li.closest('.card-wrapper');
    if (!card) return;
    var appBtn = card.querySelector('.Vtl-WishlistButton__WishlistIconButton');
    if (!appBtn) return;
    var isWishlisted = appBtn.classList.contains('wishlisted') || 
                       appBtn.getAttribute('data-wishlisted') === 'true' ||
                       appBtn.title === 'Remove from Wishlist';
    var svg = li.querySelector('svg');
    if (svg) {
      svg.style.fill = isWishlisted ? '#222222' : 'none';
      svg.style.stroke = '#222222';
    }
  });
}
new MutationObserver(syncWishlistHearts).observe(document.body, { childList: true, subtree: true, attributes: true });

// Style product page wishlist button to match compare
function applyPdpWishlistStyles() {
  var btn = document.querySelector('.comp-wish .Vtl-WishlistButton__AddToWishlist');
  if (!btn) return;

  btn.style.setProperty('border-radius', '50%', 'important');
  btn.style.setProperty('width', '54px', 'important');
  btn.style.setProperty('height', '54px', 'important');
  btn.style.setProperty('min-width', 'unset', 'important');
  btn.style.setProperty('padding', '0', 'important');
  btn.style.setProperty('border', '1px solid #d1d1d1', 'important');
  btn.style.setProperty('background', 'none', 'important');
  btn.style.setProperty('display', 'flex', 'important');
  btn.style.setProperty('align-items', 'center', 'important');
  btn.style.setProperty('justify-content', 'center', 'important');
  btn.style.setProperty('box-sizing', 'border-box', 'important');

  var svg = btn.querySelector('svg');
  if (svg) {
    svg.style.setProperty('fill', '#000000', 'important');
    svg.style.setProperty('width', '22px', 'important');
    svg.style.setProperty('height', '22px', 'important');
  }

  btn.querySelectorAll('svg path, svg polygon').forEach(function(p) {
    p.style.setProperty('fill', '#000000', 'important');
    p.style.setProperty('stroke', 'none', 'important');
  });

  // Fix wrapper height
  var wrapper = btn.parentElement;
  if (wrapper) {
    wrapper.style.setProperty('height', '54px', 'important');
    wrapper.style.setProperty('display', 'flex', 'important');
    wrapper.style.setProperty('align-items', 'center', 'important');
  }
}

function stylePdpWishlistBtn() {
  var btn = document.querySelector('.comp-wish .Vtl-WishlistButton__AddToWishlist');
  if (!btn) return;

  applyPdpWishlistStyles();
  setTimeout(applyPdpWishlistStyles, 100);
  setTimeout(applyPdpWishlistStyles, 300);
  setTimeout(applyPdpWishlistStyles, 600);
  setTimeout(applyPdpWishlistStyles, 1000);
  setTimeout(applyPdpWishlistStyles, 2000);

  // Align comp-wish container
  var container = btn.closest('.comp-wish');
  if (container) {
    container.style.setProperty('align-items', 'center', 'important');
    container.style.setProperty('height', '54px', 'important');
    container.style.setProperty('display', 'flex', 'important');
  }

    // Fix 4px vertical offset
  var wishlistDiv = document.querySelector('.comp-wish .Vtl-WishlistButton');
  if (wishlistDiv) {
    wishlistDiv.style.setProperty('margin-top', '-4px', 'important');
  }

  var styleObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.attributeName === 'style' && !btn._hovering) {
        applyPdpWishlistStyles();
      }
    });
  });
  styleObserver.observe(btn, { attributes: true, attributeFilter: ['style'] });

  btn.addEventListener('mouseenter', function() {
    btn._hovering = true;
    btn.style.setProperty('background', '#000000', 'important');
    btn.style.setProperty('border-color', '#000000', 'important');
    var svg = btn.querySelector('svg');
    if (svg) svg.style.setProperty('fill', '#ffffff', 'important');
    btn.querySelectorAll('svg path, svg polygon').forEach(function(p) {
      p.style.setProperty('fill', '#ffffff', 'important');
      p.style.setProperty('stroke', 'none', 'important');
    });
  });

  btn.addEventListener('mouseleave', function() {
    btn._hovering = false;
    applyPdpWishlistStyles();
  });
}

var pdpObserver = new MutationObserver(function() {
  if (document.querySelector('.comp-wish .Vtl-WishlistButton__AddToWishlist')) {
    stylePdpWishlistBtn();
    pdpObserver.disconnect();
  }
});
pdpObserver.observe(document.body, { childList: true, subtree: true });

// Wishlist page — redirect to product page instead of silent add to cart
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.Vtl-WishlistProduct__AddToCart');
  if (!btn) return;
  var card = btn.closest('.Vtl-WishlistProduct');
  if (!card) return;
  var link = card.querySelector('a[href*="/products/"]');
  if (!link) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  window.location.href = link.href;
}, true);


// Wishlist page — add Continue Shopping button when wishlist is empty
function injectWishlistEmptyBtn() {
  var emptyList = document.querySelector('.Vtl-WishlistPage__EmptyList');
  if (!emptyList) return;
  if (document.getElementById('wbs-continue-shopping')) return;
  var btn = document.createElement('a');
  btn.id = 'wbs-continue-shopping';
  btn.href = '/collections/all';
  btn.textContent = 'CONTINUE SHOPPING';
  btn.style.cssText = 'display:inline-block;margin-top:24px;padding:16px 32px;background:#000;color:#fff;text-decoration:none;letter-spacing:0.1em;font-size:13px;font-weight:600;';
  emptyList.appendChild(btn);
}

var emptyInterval = setInterval(function() {
  if (document.querySelector('.Vtl-WishlistPage__EmptyList')) {
    injectWishlistEmptyBtn();
    clearInterval(emptyInterval);
  }
}, 200);
setTimeout(function() { clearInterval(emptyInterval); }, 10000);

// Hide Add All to Cart button on wishlist page
function hideAddAllToCart() {
  var wrapper = document.querySelector('.Vtl-WishlistPage__AddAllWrapper');
  if (wrapper) {
    wrapper.style.setProperty('display', 'none', 'important');
    return true;
  }
  return false;
}

var hideAllInterval = setInterval(function() {
  if (hideAddAllToCart()) clearInterval(hideAllInterval);
}, 200);
setTimeout(function() { clearInterval(hideAllInterval); }, 10000);



// Remove DTX icons immediately and continuously
function removeDtxWishlistIcon() {
  document.querySelectorAll('.Vtl-WishlistIcon__Wrapper').forEach(function(el) {
    var li = el.closest('li');
    if (li) li.remove(); else el.remove();
  });
}
removeDtxWishlistIcon();
var dtxObserver = new MutationObserver(removeDtxWishlistIcon);
dtxObserver.observe(document.body, { childList: true, subtree: true });
var dtxInterval = setInterval(removeDtxWishlistIcon, 100);
setTimeout(function() { clearInterval(dtxInterval); }, 5000);

var wbsShopId = 78396424418;

function getWbsCustomerId() {
  var match = document.cookie.match(/__v__wl__c__=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function updateWbsHeaderCount(delta) {
  var counter = document.querySelector('.Vtl-WishlistHeader__HeartCounter');
  if (!counter) {
    var headerIcon = document.querySelector('.Vtl-WishlistHeader');
    if (!headerIcon) return;
    counter = document.createElement('span');
    counter.className = 'Vtl-WishlistHeader__HeartCounter';
    counter.style.cssText = 'width:15px;height:15px;font-size:9px;background-color:rgb(18,18,18);color:rgb(255,255,255);border-radius:50%;display:flex;align-items:center;justify-content:center;position:absolute;bottom:-3.5px;right:-3.5px;';
    headerIcon.style.position = 'relative';
    headerIcon.appendChild(counter);
    counter.textContent = '0';
  }
  var next = Math.max(0, (parseInt(counter.textContent) || 0) + delta);
  counter.textContent = next;
  counter.style.display = next === 0 ? 'none' : 'flex';
}

function wbsToggleWishlist(productId, variantId, heartEl) {
  var customerId = getWbsCustomerId();
  if (!customerId) { console.warn('WBS: no customerId'); return; }

  var isAdding = !heartEl.classList.contains('wbs-wishlisted');

  if (isAdding) {
    fetch('https://wishlist.sqa-api.com/bundle/api/v2/sf/ws', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain; charset=UTF-8' },
      body: JSON.stringify({
        shop_id: wbsShopId,
        customerId: customerId,
        productId: parseInt(productId),
        variantId: parseInt(variantId)
      })
    }).then(function(res) {
      if (res.ok) {
        heartEl.classList.add('wbs-wishlisted');
        heartEl.setAttribute('aria-label', 'Added to Wishlist');
        var svg = heartEl.querySelector('svg');
        if (svg) svg.style.setProperty('fill', '#e00', 'important');
        var tooltip = heartEl.closest('li.wbs-card-wishlist').querySelector('tooltip.tooltip');
        if (tooltip) tooltip.textContent = 'Added to Wishlist';
        updateWbsHeaderCount(+1);
      }
    });
  } else {
    fetch('https://wishlist.sqa-api.com/bundle/api/v2/sf/ws?sid=' + wbsShopId + '&cid=' + customerId)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var members = data && data['hydra:member'] ? data['hydra:member'] : [];
        var item = members.find(function(m) {
          var mProductId = m.product ? m.product['@id'].split('/').pop() : '';
          return String(m.variantId) === String(variantId) ||
                 String(m.productId) === String(productId) ||
                 String(mProductId) === String(productId) ||
                 String(m.id) === String(productId);
        });
        if (!item) { console.warn('WBS: item not found in', members.length, 'items'); return; }
        var atId = item['@id'] || '';
        var itemId = atId.split('/').pop() || item.id;
        return fetch('https://wishlist.sqa-api.com/bundle/api/v2/sf/ws/' + wbsShopId + '/' + customerId + '/' + itemId, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json; charset=UTF-8' }
        }).then(function(res) {
          if (res.ok) {
            heartEl.classList.remove('wbs-wishlisted');
            heartEl.setAttribute('aria-label', 'Add to Wishlist');
            var svg = heartEl.querySelector('svg');
            if (svg) svg.style.setProperty('fill', '#000', 'important');
            var tooltip = heartEl.closest('li.wbs-card-wishlist').querySelector('tooltip.tooltip');
            if (tooltip) tooltip.textContent = 'Add to Wishlist';
            updateWbsHeaderCount(-1);
          }
        });
      });
  }
}

function attachWbsClickHandlers() {
  document.querySelectorAll('li.wbs-card-wishlist a.wbs-card-heart:not([data-wbs-styled])').forEach(function(a) {
    a.setAttribute('data-wbs-styled', '1');

    a.style.setProperty('display', 'flex', 'important');
    a.style.setProperty('align-items', 'center', 'important');
    a.style.setProperty('justify-content', 'center', 'important');
    a.style.setProperty('width', '45px', 'important');
    a.style.setProperty('height', '45px', 'important');
    a.style.setProperty('background', '#fff', 'important');
    a.style.setProperty('border-radius', '50%', 'important');
    a.style.setProperty('cursor', 'pointer', 'important');
    var svg = a.querySelector('svg');
    if (svg) {
      svg.style.setProperty('fill', '#000', 'important');
      svg.style.setProperty('width', '20px', 'important');
      svg.style.setProperty('height', '20px', 'important');
    }

    a.addEventListener('mouseenter', function() {
      a.style.setProperty('background', '#000', 'important');
      var svg = a.querySelector('svg');
      if (svg) svg.style.setProperty('fill', '#fff', 'important');
    });
    a.addEventListener('mouseleave', function() {
      a.style.setProperty('background', '#fff', 'important');
      var svg = a.querySelector('svg');
      if (svg) svg.style.setProperty('fill', a.classList.contains('wbs-wishlisted') ? '#e00' : '#000', 'important');
    });

    a.addEventListener('click', function(e) {
      e.preventDefault();
      var productId = a.getAttribute('data-wbs-product-id');
      var handle = a.getAttribute('data-wbs-product-handle');
      var attempts = 0;

      function tryToggle() {
        if (!getWbsCustomerId()) {
          if (attempts++ < 10) { setTimeout(tryToggle, 300); }
          else { console.warn('WBS: cookie never set'); }
          return;
        }
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            var variantId = product.variants && product.variants[0] ? product.variants[0].id : parseInt(productId);
            wbsToggleWishlist(productId, variantId, a);
          });
      }
      tryToggle();
    });
  });
}

var wbsClickInterval = setInterval(attachWbsClickHandlers, 300);
setTimeout(function() { clearInterval(wbsClickInterval); }, 10000);

if (window.location.pathname === '/apps/page/wishlist') {
  // Hide variant label
  var style = document.createElement('style');
  style.textContent = '.Vtl-WishlistProduct__Variant { display: none !important; }';
  document.head.appendChild(style);

  // Rename "Add to cart" to "Add to bag"
  function renameAddToCart() {
  document.querySelectorAll('button, a').forEach(function(el) {
    var text = el.textContent.trim();
    if (text === 'Add to cart') {
      el.textContent = 'SELECT OPTIONS';
    }
    if (text === 'Select options') {
      el.textContent = 'Select Options';
    }
  });
}

  renameAddToCart();
  var cartObserver = new MutationObserver(renameAddToCart);
  document.addEventListener('DOMContentLoaded', function() {
    cartObserver.observe(document.body, { childList: true, subtree: true });
  });

  // Reload when all items deleted
  var origFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    return origFetch.apply(this, args).then(function(res) {
      var url = args[0] || '';
      if (typeof url === 'string' && url.indexOf('/sf/ws/') > -1 && res.status === 204) {
        setTimeout(function() {
          var emptyList = document.querySelector('.Vtl-WishlistPage__EmptyList');
          var hasItems = document.querySelector('.Vtl-WishlistPage__ProductList, [class*="ProductList"]');
          if (emptyList && (!hasItems || hasItems.children.length === 0)) {
            window.location.reload();
          }
        }, 800);
      }
      return res;
    });
  };
}

// Clean app-injected elements from Recently Viewed image boxes
(function(){
  function cleanKhusiBoxes(){
    var boxes = document.querySelectorAll('#khusi-recently-viewed .khusi-image-box');
    boxes.forEach(function(box){
      Array.from(box.children).forEach(function(el){
        if(!el.classList.contains('khusi-image')) el.remove();
      });
    });
  }

  var observer = new MutationObserver(function(){
    if(document.getElementById('khusi-recently-viewed')){
      cleanKhusiBoxes();
      setTimeout(cleanKhusiBoxes, 2000);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
